export default "__VITE_ASSET__2f25028e__"